import { BuildingType } from "../types/BuildingTypeEnums";
import house_placeholder from "../Images/house_placeholder.png";
import archipelago_toilet_placholder from "../Images/archipelago_toilet_placeholder.png";

/**
 * Returns the appropriate placeholder image based on building type
 * @param buildingType The type of building
 * @returns Path to the placeholder image
 */
export const placeholderForBuildingType = (buildingType?: BuildingType): string => {
    switch (buildingType) {
        case BuildingType.toiletArchipelago:
            return archipelago_toilet_placholder;
        case BuildingType.toiletReserve:
            return house_placeholder;
        case BuildingType.complement:
            return house_placeholder;
        case BuildingType.other:
            return house_placeholder;
        case BuildingType.standard:
        default:
            return house_placeholder;
    }
};